  window.Shoppad = window.Shoppad || {},
  window.Shoppad.apps = window.Shoppad.apps || {},
  window.Shoppad.apps.infiniteoptions = {
    ready: function() {

      function callback() {
        $('#infiniteoptions-container .datepicker').datepicker({
          inline: true,
          minDate:0,
          defaultDate:0,
          beforeShowDay: function(date) {
            var unavailableDayMonthYear = [

              ["12-10-2022", "Sold Out"],
              ["13-10-2022", "Sold Out"],
              ["15-10-2022", "Sold Out"],
              ["23-10-2022", "Sold Out"],
              ["30-10-2022", "Sold Out"],
              ["8-8-2022", "Sold Out"],
              ["9-8-2022", "Closed"],
              ["28-7-2022", "Closed"],
              ["29-7-2022", "Closed"],
              ["30-7-2022", "Sold Out"],
              ["13-8-2022", "Closed"],
              ["15-8-2022", "Closed"],
              ["26-8-2022", "Sold Out"],
              ["1-9-2022", "Sold Out"],
              ["31-12-2023", "Sold Out"],
              ["7-11-2023", "Sold Out"],
              ["5-10-2022", "Sold Out"],
              ["17-9-2022", "Sold Out"],
              ["18-9-2022", "Sold Out"],
              ["21-9-2022", "Sold Out"],
              ["23-9-2022", "Sold Out"],
              ["12-10-2022", "Sold Out"],
              ["13-10-2022", "Sold Out"],
              ["19-10-2022", "Sold Out"],
              ["10-5-2023", "Sold Out"],
              ["21-10-2022", "Sold Out"],
              ["22-10-2022", "Sold Out"],
              ["23-10-2022", "Sold Out"],
              ["1-11-2022", "Sold Out"],
              ["2-11-2022", "Sold Out"],
              ["7-11-2023", "Closed"],
              ["11-11-2022", "Closed"],
              ["12-11-2022", "Closed"],
              ["13-11-2022", "Closed"],
              ["14-11-2022", "Sold Out"],
              ["17-11-2022", "Sold Out"],
              ["18-11-2022", "Sold Out"],
              ["22-11-2022", "Sold Out"],
              ["8-5-2023", "Sold Out"],
              ["24-11-2022", "Sold Out"],
              ["25-11-2022", "Sold Out"],
              ["26-11-2022", "Sold Out"],
              ["27-11-2022", "Sold Out"],
              ["22-9-2022", "Closed - National Day of Mourning"],
              ["3-12-2022", "Closed - Queens Birthday"],
              ["2-12-2022", "Closed - Labour Day"],
              ["6-12-2022", "Sold Out"],
              ["1-6-2023", "Sold Out"],
              ["8-12-2022", "Sold Out"],
              ["10-08-2024", "Sold Out"],
              ["11-08-2024", "Sold Out"],
              ["25-11-2023", "Sold Out"],
              ["22-11-2023", "Sold Out"],
              ["22-12-2023", "Sold Out"],   
              ["29-11-2023", "Sold Out"],
              ["25-12-2023", "Closed - Christmas Day"],
              ["26-12-2023", "Closed - Boxing Day"],
              ["1-1-2024", "Closed"],
              ["2-1-2024", "Closed"],
              ["3-1-2024", "Closed"],
              ["4-1-2024", "Closed"],
              ["5-1-2024", "Closed"],
              ["2-2-2024", "Closed"],
              ["26-1-2024", "Closed - Australia Day"],
              ["2-10-2023", "Closed"],
              ["29-4-2023", "Closed - Easter Monday"],             
              ["31-1-2023", "Closed"]
            ];    

            return function (date) {
              var dayMonthYear = (date.getDate() + "-" + (date.getMonth()+1) + "-" + date.getFullYear());
              var now = new Date();

              // **************** SETTINGS - EDIT HERE! *****************
              var isDaylightSavings = false;
              
              var allowSaturdayOrders = true;
              var allowSundayOrders = true;
              
              var allowSameDay = true;
              var sameDayCutOff24Hour = 14;
              var sameDayWeekendCutOff24Hour = 11;   // for Saturday cut-off 
              // ********************************************************
              
              // Determine 'now' relative to Sydney timezone (for customers overseas)
              var localTime = now.getTime();
              var localOffset = now.getTimezoneOffset() * 60000;	// in milliseconds
              var utc = localTime + localOffset;
              if (isDaylightSavings == true) {
                var syd = utc + (3600000*11);
              }
              else {
                var syd = utc + (3600000*10);    // 11 for AEDT (Daylight Savings) otherwise 10 for AEST
              }
              var sydNow = new Date(syd);

              // ***** Restrict weekend orders
              if (date.getDay() == 6) {
                if (allowSaturdayOrders == false) {
                  return [false, '', 'Saturday orders not permitted']
                }
              }

              if (date.getDay() == 0) {
                if (allowSundayOrders == false) {
                  return [false, '', 'Sunday orders not permitted']
                }
              }
              
              // ***** Restrict same day orders
              if (date.getFullYear() == sydNow.getFullYear() &&
                date.getMonth() == sydNow.getMonth() &&
                date.getDate() == sydNow.getDate()) { 
                  if (allowSameDay == false) {
                    return [false, '', 'Same day orders not permitted'];
                  }
                  else {
                    if (sydNow.getHours() >= sameDayCutOff24Hour) {
                     return [false, '', 'Past cutoff - please give us a call'];
                    }
                  }
              }

              // ***** Prevent orders on weekends after midday Saturday
              if (date.getDay() == 0 || date.getDay() == 6) {
                var cutOffDateTime = new Date(date.getTime());     // Subtract 2 days from Sunday or 1 day from Saturday to get the Friday before
                cutOffDateTime.setDate((date.getDay() == 0) ? (date.getDate() - 1) : (date.getDate()));         //FOR SATURDAY CUT-OFF
                cutOffDateTime.setHours(sameDayWeekendCutOff24Hour);     // Set cutoff time
                console.log("DATE: " + date + ", CUTOFF: " + cutOffDateTime + ", NOW: " + sydNow);
                if (sydNow > cutOffDateTime) {
                   return [false, '', 'Weekend orders must be placed before 12pm Saturday'];
                }
              }
             
              // ***** Prevent orders on public holidays
              var i;
              for (i = 0; i < unavailableDayMonthYear.length; i += 1) {
                if (unavailableDayMonthYear[i][0] == dayMonthYear) {
                  return [false, '', unavailableDayMonthYear[i][1]];
                }
              };
              return [true]; //Enabled by default
            }(date)
			},

          altField: '#infiniteoptions-container .datepicker input[type=text]',
          //altFormat: "dd-mm-yy",  //ORIGINAL FORMAT i.e. 09-02-2020
          altFormat: "DD d M yy", // NEW FORMAT i.e. Monday 9 Feb 2020
          onSelect: function() {
            $('#infiniteoptions-container .ui-datepicker-inline').hide();
          }
        });

        $('#infiniteoptions-container .datepicker input[type=text]').change(function(){
          $('#infiniteoptions-container .datepicker').datepicker('setDate', $(this).val());
        });

        $('#infiniteoptions-container .datepicker').datepicker( "setDate", '' );

        $('#infiniteoptions-container .datepicker input[type=text]').attr('readonly','true');

        $('#infiniteoptions-container .ui-datepicker-inline').hide();

        $('#infiniteoptions-container .datepicker input[type=text]').on('click touchstart', function (e) {
              $('#infiniteoptions-container .ui-datepicker-inline').show();
        });
      }

      $(document).on('mouseup touchstart', function(e) {
        var isDatePickerInput = $('#infiniteoptions-container .datepicker input').is(e.target);
        var isDatePicker = $('#infiniteoptions-container .ui-datepicker-inline').is(e.target);
        var isChildOfDatePicker = $('#infiniteoptions-container .ui-datepicker-inline').has(e.target).length;

        // If the target of the click isn't the text input, the date picker, or a descendant of the date picker
        if (!isDatePickerInput && !isDatePicker && !isChildOfDatePicker) {
          $('#infiniteoptions-container .ui-datepicker-inline').hide();
        }
      });

      if (window.jQuery.fn.datepicker) {
        callback();
      } else {
        var script = document.createElement('script');
        script.src = '//code.jquery.com/ui/1.10.2/jquery-ui.js';
        script.onload = callback;
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    }
  };